/**
 * Converts Unicode characters to GSM-7 compatible equivalents
 * GSM-7 is the standard character set for SMS messages
 */
function toGSM7(text: string): string {
  return (
    text
      .replace(/[\u2018\u2019]/g, "'") // smart single quotes
      .replace(/[\u201C\u201D]/g, '"') // smart double quotes
      .replace(/\u2013/g, '-') // en dash
      .replace(/\u2014/g, '-') // em dash
      .replace(/\u2026/g, '...') // ellipsis
      .replace(/\u00A0/g, ' ') // non-breaking space
      // eslint-disable-next-line no-control-regex
      .replace(/[^\u0000-\u007F]/g, '')
  ); // strip any remaining non-ASCII
}

/**
 * Sanitizes text content for SMS messages
 * - Converts Unicode characters to GSM-7 compatible equivalents
 * - Trims leading/trailing whitespace
 * - Normalizes multiple spaces to single space
 * - Removes control characters except newlines
 */
export function sanitizeTextMessage(text: string): string {
  if (!text || typeof text !== 'string') {
    return '';
  }

  // eslint-disable-next-line no-control-regex
  const controlCharsRegex = /[\u0000-\u0009\u000B\u000C\u000E-\u001F\u007F]/g;

  return toGSM7(text)
    .trim()
    .replace(/[^\S\n]+/g, ' ') // Replace multiple spaces/tabs (but not newlines) with single space
    .replace(controlCharsRegex, ''); // Remove control characters except newline (\u000A) and carriage return (\u000D)
}
